<template>
  <div id="app">

    <el-container class="ciyemian_yibei_qiangzhi_buxudong flextext">
      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">
      <home-head></home-head>
      <el-main>
        <div class="contain">
          <!--  <div><a href="#" class="small-nav">全
          部 》离子色谱仪&nbsp;阴阳离子检测仪水中离子测定仪</a></div>-->
          <div class="small-title">{{list.title}}</div>
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="9">
                <div class="shop_list">
              <el-image class="shop1" :src="url+'/storage/'+list.cover" fit="cover">
                <div slot="error" class="image-slot">
                  <img class="weijiazai_img_qiangzhi" src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                       alt="" style="height: 220px">
                  <!--                        <i class="el-icon-picture-outline"></i>-->
                </div>

              </el-image>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="15 ">
              <!--              <div class="shop-span">-->
              <!--                <ul style="position: absolute">-->
              <!--                  <li v-if="list.jiaofu==2">-->
              <!--                    现货-->
              <!--                  </li>-->

              <!--                  <li v-if="list.jiaofu==3">-->
              <!--                    订货-->
              <!--                    <div class="jiaofu_time">{{ list.jiaofu_date + '天' }}</div>-->
              <!--                  </li>-->
              <!--                </ul>-->

              <!--              </div>-->
              <div style="margin-bottom: 30px;margin-left: 50px" >
                <div>
                  <div class="guige_tou" v-if="type == 3 ||type == 2">
                    <span style="margin-right: 65px; float: left">服务区域</span>
                    <span v-for="(item,index) of fwsheng" :key="index">
                      {{ index == fwsheng.length-1 && item || (item + ',') }}
                    </span>
                  </div>
                  <div class="guige_tou" v-if="type == 1">
                    <span style="margin-right: 65px; float: left">服务区域</span>
                    <span v-for="(item,index) of fwsheng" :key="index" style="margin-right: 10px">{{ item }}</span>
                    <span>:</span>
                    <span v-for="(item,index) of fwshi" :key="index">
                      {{ index == fwshi.length-1 && item || (item + ',') }}
                    </span>
                  </div>
            <span class="prices" v-if="list.price_yugu==0.00">明码标价
            <span class="moneys">¥</span><span class="value">{{ list.cash }}</span>
            </span>
                  <span class="prices" v-else>预估价格
                <span class="moneys">¥</span><span class="value">{{ list.price_yugu }}</span>
                  </span>
                </div>
                <div v-for="(item,index) of list.attachment" v-bind:key="index">
                  <div class="guige_tou" v-if="item">
                    <span style="margin-right: 65px; float: left">附件</span>
                    <a :href="url+'/storage/'+item.url"
                       style="display: block; float: left; margin-left: 35px"
                       target="_blank">
                      <el-link type="primary">{{ item.name }}</el-link>
                    </a>
                  </div>
                </div>
                <div v-for="(item,index) of list.cert_file" v-bind:key="index">
                  <div class="guige_tou" v-if="item.url">
                    <span style="margin-right: 65px; float: left">必要资质</span>
                    <a :href="url+'/storage/'+item.url" style="display: block; float: left">
                      <el-link type="primary">{{ item.url }}</el-link>
                    </a>
                  </div>
                </div>
                <!--              <div class="guige_middle">-->
                <!--                <div class="zizhi">必要资质</div>-->
                <!--&lt;!&ndash;                <a :href="url+'/storage/'+list.cert_file.url" style="display: block; float: left">&ndash;&gt;-->
                <!--&lt;!&ndash;                  <el-link type="primary">{{list.cert_file.name}}</el-link>&ndash;&gt;-->
                <!--&lt;!&ndash;                </a>&ndash;&gt;-->
                <!--              </div>-->
              </div>
              <el-divider class="hr"></el-divider>

              <span class="prices-one" v-for="(item,index2) in list_guige" :key="index2">
             <span style="display: block; float: left" v-if="index2==0">规格型号</span>
            <span class="moneys-num" :style="index2==0?'':'margin-left:135px; width:100px'">{{
                item.specification
              }}</span>
            <span class="moneys-nums" style="width: 100px">{{ item.price * item.sum }}元</span>
              <span class="jibuqi">
            <el-input-number size="mini" v-model="item.sum" @change="handleChange2" :min="0" :max="10"
                             label="描述文字"></el-input-number>
              </span>
              <el-divider class="hrs"></el-divider>
              </span>

              <!--            <span class="prices-one" v-for="(item,index2) in list.specification" :key="index2" style="margin-left: 80px">-->
              <!--            <span class="moneys-num">{{ item.specification }}</span>-->
              <!--            <span class="moneys-nums">{{item.price}}元</span>-->
              <!--              <span class="jibuqi">-->
              <!--            <el-input-number  size="mini" v-model="num[index2]" @change="handleChange2" :min="0" :max="10"-->
              <!--                              label="描述文字"></el-input-number>-->
              <!--              </span>-->
              <!--              </span>-->
              <!--            <el-divider class="hrs"></el-divider>-->
              <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
              <!--              <span style="margin-right: 65px">附件</span>-->
              <!--              <a :href="url+'/storage/'+list.attachment[0].url">-->
              <!--                <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
              <!--              </a>-->
              <!--            </div>-->
              <span class="buy">
            <a :href="'#/service/purchase/'+list.id">
                <el-button class="buy-button" type="primary">立即购买</el-button>
            </a>
            </span>
              <span class="buy">
<!--            <a :href="'#/purchase/'+list.id">-->
          <el-button class="buy-button" type="primary" @click="shouce(list.id)">{{ status }}</el-button>
                <!--              </a>-->
            </span>
            </el-col>
            <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
            <!--            <span class="prices-one" >附件</span>-->
            <!--            <a href="url+'/storage/'+list.attachment[0].url" class="moneys-img">asdfghjkli.jpg</a>-->
            <!--              <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
            <!--            </div>-->


          </el-row>
          <div style="margin-bottom: 40px; height: 400px; width: 100%">
            <div class="aaa hidden-sm-and-down">
              <div class="xinxi">
                <div class="xinxi3">
                  <div class="title-gs">{{ inform.shop_name }}</div>
                </div>

                <!--                <span class="title-rain">雨纷纷</span>-->
                <!--                <el-divider class="shuxian" direction="vertical"></el-divider>-->
                <!--                <span class="title-rains">旧故里</span>-->
                <!--                <el-divider class="hengxian"></el-divider>-->
                <el-row :gutter="2" class="lxtop">
                  <el-col class="word-shop" :span="9" :offset="2">用户名:</el-col>
                  <el-col class="word-shop" :span="9">{{ inform.name }}</el-col>
                </el-row>
                <el-row :gutter="2" class="lxtop">
                  <el-col class="word-shop" :span="9" :offset="2">联系方式:</el-col>
                  <el-col class="word-shop" :span="9">{{ inform.mobile }}</el-col>
                </el-row>
                <el-row :gutter="2" class="lxtop">
                  <el-col class="word-shops" :span="9" :offset="2"
                          v-if="inform.province||inform.city||inform.area||inform.auth_info.province||inform.auth_info.city||inform.auth_info.area !==''"> 所在区域:
                  </el-col>
                  <el-col class="word-shops" :span="9">{{ sheng }}{{ shi }}{{ qv }}</el-col>
                </el-row>
                <div class="buttons">
                  <button><a :href="'#/shops/index/'+list.shop_id">进入店铺</a></button>
                </div>
              </div>
            </div>
            <div class="bottom_right_background">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="详情描述" name="first">
                  <div class="xiangqing_background1"></div>
                  <div class="xiangqing_background">
<!--                    <div class="xiangqing_title" style="float: left;margin-left: 23px">-->
<!--                      行业领域：<span class="tanxing">{{yingyong_hy}}</span>-->
<!--                    </div>-->
                    <div class="xiangqing_title " >
                      <span style="float: left;margin-left:23px">服务领域：</span>
                      <span>
                          <el-row  v-for="(item,index) in yingyong_hy.split(',')" v-bind:key="index"
                                   style="display: flex">
                              <el-col v-if="index % 2 == 0" class="title" >
                                  <block> {{yingyong_hy.split(',')[index]}}</block>
                                 <block class="title_list">  {{yingyong_hy.split(',')[index+1]}}</block>
                              </el-col>
                          </el-row>
                          </span>
                    </div>
                    <div class="xiangqing_title " >
                      <span style="float: left;margin-left: 90px">服务关键词：</span>
                      <span>
                          <el-row  v-for="(item,index) in list.keywords.split(',')" v-bind:key="index"
                                   style="display: flex">
                              <el-col v-if="index % 2 == 0" class="title" >
                                  <block> {{list.keywords.split(',')[index]}}</block>
                                 <block class="title_list">  {{list.keywords.split(',')[index+1]}}</block>
                              </el-col>
                          </el-row>
                          </span>
                    </div>
<!--                    <div class="xiangqing_title xianshi" style="text-overflow: ellipsis; overflow: hidden ;-->
<!--                    float: left;margin-left: 90px" :title="list.keywords">-->
<!--                      服务关键词：<span class="tanxing">{{list.keywords}}-->
<!--                    </span>-->
<!--                    </div>-->
                  </div>
                  <div class="clear"></div>
                  <div class="xiangqing_background1"></div>
                  <div class="bottom_titlemiaoshu imgsize" v-html="list.detail"></div>
                </el-tab-pane>
                <!--                <el-tab-pane label="配置方案" name="second">-->
                <!--                  <div class="xiangqing_background1"></div>-->
                <!--                  <div class="bottom_titlemiaoshu" v-html="list.configuration"></div>-->
                <!--                </el-tab-pane>-->
                <el-tab-pane label="案例解析" name="third">
                  <div class="xiangqing_background1"></div>
                   <div v-for="(item,index) of list.list_cases" :key="index" >
                     <a v-if="item" v-bind:href="'#/dianpu_fuwucase/'+ item.id">
                       <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                            v-html="item.title"></div>
                     </a>
                   </div>
<!--                  <a v-if="list.list_cases[0]" v-bind:href="'#/case_details/'+ list.list_cases[0].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_cases[0].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_cases[1]" v-bind:href="'#/case_details/'+ list.list_cases[1].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_cases[1].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_cases[2]" v-bind:href="'#/case_details/'+ list.list_cases[2].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_cases[2].title"></div>-->
<!--                  </a>-->
                </el-tab-pane>
                <el-tab-pane label="小星点灯" name="fourth">
                  <div class="xiangqing_background1"></div>
                  <div v-for="(item,index) of list.list_light" :key="index">
                                      <a v-if="item" v-bind:href="'#/detailsfuwu/'+ item.id">
                                      <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                           v-html="item.title"></div>
                                    </a>
                  </div>
                  <!--                  <div v-if="list.list_light[0]!==''" class="bottom_titlemiaoshu"  v-html="list.list_light[0].title"></div>-->
<!--                  <a v-if="list.list_light[0]" v-bind:href="'#/lighting_details/'+ list.list_light[0].id">-->
<!--                  <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                       v-html="list.list_light[0].title"></div>-->
<!--                </a>-->
<!--                  <a v-if="list.list_light[1]" v-bind:href="'#/lighting_details/'+ list.list_light[1].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_light[1].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_light[2]" v-bind:href="'#/lighting_details/'+ list.list_light[2].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_light[2].title"></div>-->
<!--                  </a>-->
                </el-tab-pane>
                <el-tab-pane label="应用方案" name="fifth">
                  <div class="xiangqing_background1"></div>
                  <div v-for="(item,index) of list.list_applicationProgram" :key="index">
                    <a v-if="item" v-bind:href="'#/college/programme/'+ item.id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="item.title"></div>
                                      </a>
                  </div>
<!--                  <a v-if="list.list_applicationProgram[0]"
                    v-bind:href="'#/college/programme/'+ list.list_applicationProgram[0].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_applicationProgram[0].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_applicationProgram[1]"-->
<!--                     v-bind:href="'#/college/programme/'+ list.list_applicationProgram[1].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_applicationProgram[1].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_applicationProgram[2]"-->
<!--                     v-bind:href="'#/college/programme/'+ list.list_applicationProgram[2].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_applicationProgram[2].title"></div>-->
<!--                  </a>-->
                </el-tab-pane>
                <el-tab-pane label="行业标准" name="sixth">
                  <div class="xiangqing_background1"></div>
                  <div v-for="(item,index) of list.list_norm" :key="index">
                    <a v-if="item" v-bind:href="'#/college/standard/'+ item.id">
                                          <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                               v-html="item.title"></div>
                                        </a>
                  </div>
<!--                  <a v-if="list.list_norm[0]" v-bind:href="'#/college/standard/'+ list.list_norm[0].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_norm[0].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_norm[1]" v-bind:href="'#/college/standard/'+ list.list_norm[1].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_norm[1].title"></div>-->
<!--                  </a>-->
<!--                  <a v-if="list.list_norm[2]" v-bind:href="'#/college/standard/'+ list.list_norm[2].id">-->
<!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
<!--                         v-html="list.list_norm[2].title"></div>-->
<!--                  </a>-->
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </el-main>
      <footerall></footerall>
    </el-container>
  </div>
</template>

<script>
    import home_head from '../../common/home-head';
    import {CodeToText} from "element-china-area-data";
    import footerall from "../../common/footer";
    export default {
        name: "category",
        data: function () {
            return {
                favorite: false,
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                },
                anli: [],
                diandeng: [],
                fangan: [],
                biaozhun: [],
                yingyong_hy: [],
                value: 5,
                activeName: 'first',
                list: '',
                status: '',
                list_guige: [],
                url: '',
                num: [
                    '', '', ''
                ],
                information: '',
                inform: "",
                imforid:'',
                fwsheng:[],
                fwshi:[],
                type: '',
            }
        },
        components: {
            'home-head': home_head,
            footerall
        },
        methods: {

            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)

            },
            init() {
                this.information = this.$store.state.information
                this.list_data()
                this.zhuangtai()
                this.url = window.config.api_url
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
          zhuangtai() {
            var t = this
            var id = localStorage.getItem('token')
            var url = window.config.api_url + '/user/fuwu/focus/check/' + t.$route.params.id + '?token=' + id
            t.axios.get(url).then(res => {
              t.status = res.data.focus
              t.status = res.data.focus == 0 ? '收藏服务' : '已收藏'
            })
          },
          shouce() {
            // console.log(cet);
            var t = this
            var id = localStorage.getItem("uid")
            var formData = new FormData();
            formData.append('token', id);
            formData.append('fuwu_id', this.$route.params.id);
            if (t.status == '收藏服务') {
              var url = window.config.api_url + '/user/fuwu/focus'
              t.axios.post(url, formData).then(res => {

                t.$code(res.data.status)
                if (res.data.status == 1) {
                  t.open2('成功')
                  this.$router.go(1);
                }
              })
              this.status='已收藏'
            } else {
              var url1 = window.config.api_url + '/user/fuwu/unfocus'
              t.axios.post(url1, formData).then(res => {
                // console.log(res)
                t.$code(res.data.status)
                if (res.data.status == 1) {
                  t.open2('成功')
                  this.$router.go(1);
                }
              })
              this.status='收藏服务'
            }
          },
            dp_inform() {
                var t = this;
                var url = window.config.api_url + '/college/shop/info?id=' + t.imforid
                t.axios.get(url).then(res => {
                    t.inform = res.data
                    t.type = res.data.type
                    console.log(res.data.type)
                    CodeToText[res.data.auth_info.province] === undefined ? t.sheng = res.data.auth_info.province_name : t.sheng = CodeToText[res.data.auth_info.province]
                    CodeToText[res.data.auth_info.city] === undefined ? t.shi = res.data.auth_info.city_name : t.shi = CodeToText[res.data.auth_info.city];
                    CodeToText[res.data.auth_info.area] === undefined ? t.qv = res.data.auth_info.area_name : t.qv = CodeToText[res.data.auth_info.area];
                })
            },
            goumai_sj(e) {
                var t = this
                var list_vu = []
                t.list_guige.forEach(function (item) {
                    if (item.sum !== 0) {
                        list_vu.push({
                            estimate: item.estimate,
                            goods_id: item.goods_id,
                            id: item.id,
                            price: item.price,
                            specification: item.specification,
                            sum: item.sum
                        })
                    }
                })
                if (list_vu == '') {
                    return t.$message.error('请至少选择一个商品规格');
                }

                t.$store.commit('saveDbSource', list_vu)
                window.location = "#/purchase/" + e
            },
            list_data() {
                var t = this
                var url = window.config.api_url + '/college/fuwu/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.list = res.data;
                    console.log('1212121',res.data);
                    t.fwsheng = res.data.province.split(',').map((item)=>{
                        return CodeToText[item]
                    })
                    t.fwshi = res.data.city.split(',').map((item)=>{
                        return CodeToText[item]
                    })
                    console.log(t.fwsheng);
                    console.log(t.fwshi)

                    t.imforid = res.data.shop_id
                    for (let i = 0; i < t.list.aac.length; i++) {
                        t.yingyong_hy.push(t.list.aac[i].title)
                    }
                    t.yingyong_hy = t.yingyong_hy.join(',')
                    //  = res.data.specification
                    // res.data.specification.forEach(function (item) {
                    //   t.list_guige.push({
                    //     estimate: item.estimate,
                    //     goods_id: item.goods_id,
                    //     id: item.id,
                    //     price: item.price,
                    //     specification: item.specification,
                    //     sum: 0
                    //   })
                    //   // console.log(item)
                    // })
                    //22222222222222222222
                    res.data.specification.forEach(function (item) {
                        t.list_guige.push({
                            estimate: item.estimate,
                            goods_id: item.fuwu_id,
                            id: item.id,
                            price: item.price,
                            specification: item.specification,
                            sum: 0
                        })
                        // console.log(item)
                    })

                    t.dp_inform()
                    console.log(t.list_guige, 888888888888999999)

                })

            },
            fujiaxz(e) {
                this.$router.push(this.url + '/storage/' + e);
            },
            handleChange2(e) {
                this.$store.commit('savePath', e)

            },
            open3(eve) {//警告
                // var tishi = '最多只能设置三个标签'
                this.$message({
                    showClose: true,
                    message: eve,
                    type: 'warning'
                });
            },
            open2(eve) {//成功
                this.$message({
                    showClose: true,
                    message: eve,
                    type: 'success'
                });
            },
        },

        created() {
            this.init()
        },
          mounted() {
            setTimeout(() =>{
                this.dp_inform()
            },500);
        }
    }

</script>
<style lang="less">
  .home_shop_xiang_peizhi_qiangzhi_elementui_leixing {
    .el-tabs__nav-wrap::after {
      background-color: #FFFFFF !important;
      width: 0;
    }
  }

</style>


<style>
  .imgsize p img{
    max-width: 100%;
  }
  .xianshi {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ciyemian_yibei_qiangzhi_buxudong .el-tabs__active-bar {
    background-color: #4E6EF2;
    left: 1px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-left:before {
    display: none !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-right:before {
    display: none !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    /*padding: 0 14px!important;*/
    /*font-size: 14px!important;*/
    line-height: 47px;
    font-size: 18px !important;
    padding-right: 83px !important;
    /*margin-right: 88px;*/
    /*padding: 0 44px!important;*/
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .el-tabs__nav-scroll {
    margin-left: 45px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .el-tabs__item {
    padding: 0 !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .el-tab-pane {

    margin-left: 35px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom[data-v-7edfb125] {
    left: -10px;
  }

  @media screen and (min-width: 995px) and (max-width: 1500px) {

    .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
      width: 100% !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
      padding-right: 25px !important;
      /*margin-right: 26px;*/
      font-size: 15px !important;
      /*padding-left: 25px;*/
      height: 45px;
      font-weight: bold;
      color: #333333;
    }
  }

  @media screen and (min-width: 750px) and (max-width: 995px) {
    .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
      width: 100% !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
      padding-right: 24px !important;
      font-size: 16px !important;
      height: 45px;
      font-weight: bold;
      color: #333333;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
      width: 100%;
      position: relative;
      box-sizing: border-box;
      padding-left: 0px !important;
      margin-top: 25px;

    }
  }

  @media screen and (max-width: 750px) {
    .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
      width: 100% !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .contain {
      width: 100% !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .moneys-num {
      margin-left: 55px !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .moneys-nums {
      margin-left: 45px !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
      padding-right: 4px !important;
      font-size: 13px !important;
      height: 45px;
      font-weight: bold;
      color: #333333;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
      width: 100%;
      position: relative;
      box-sizing: border-box;
      padding-left: 0px !important;
      margin-top: 25px;

    }

    .ciyemian_yibei_qiangzhi_buxudong .jibuqi {
      margin-left: 50px !important;
    }
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom div {
    margin-left: 23px;
    margin-right: 40px !important;
    float: left;
    font-size: 14px;
    color: #666666;
    line-height: 60px;
  }

  .jibuqi {
    margin-left: 68px;
  }

  .jibuqi .el-input__inner {
    padding: 0;
    border: 0px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-minus:before {
    font-size: 14px !important;
    color: #FFFFFF;
    font-weight: bold;
    content: "\e6d8";
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-plus:before {
    font-size: 14px !important;
    color: #FFFFFF;
    font-weight: bold;
    content: "\e6d9";
  }

  .jibuqi .el-input-number--mini {
    width: 98px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__increase {
    width: 27px;
    background: #4E6EF2 !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__decrease {
    width: 27px;
    background: #4E6EF2 !important;
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

  @head_text: Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  @import "../../../assets/css/home_details";
  //@import "../../../assets/css/goods_detailed";
  .flextext {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;
  }
</style>